export default {
  activateLandingPageTitle: '活動',
  activateProductCardTitle: '活動',
  activateProductPageTitle: '預訂活動',
  allProductsLandingPageTitle: '預訂獨特體驗',
  apply: '套用',
  buyTickets: '購買票券',
  cancel: '取消',
  clear: '清除',
  clearFilters: '清除篩選器',
  discoverExperiences: '探索體驗',
  exclusive: '獨家',
  experience: '體驗',
  experiencePhotoOfListing: '{{listingTitle}} 的體驗照片 {{photoNumber}}',
  experiences: '體驗',
  filterExperiences: '篩選體驗',
  fromListingCard: '從',
  hostedBy: '主辦單位：',
  hostLandingPageTitle: '在地體驗',
  hostProductCardTitle: '在地體驗',
  hostProductPageTitle: '預訂在地體驗',
  landingPageTitle: '預訂獨特體驗',
  mainLandingPageTitle: '所有體驗',
  more: '更多',
  noExperiencesFound: '找不到體驗',
  noExperiencesFoundFor: '找不到相關體驗',
  experiencesFoundCount: '找到 {{count}} 個體驗',
  profileImageOfHost: '{{hostName}} 的個人資料圖片',
  reserve: '預訂',
  reserveLandingPageTitle: '活動與設施',
  reserveProductCardTitle: '活動',
  reserveProductPageTitle: '預訂活動與設施',
  resultsPageTitle: '預訂體驗與活動',
};
